<section class="p-0 m-0">
  <div class="FirstScroll_Section" style="background-color: #cecccc;">
    <h3 class="SectionHeading">List of Institutes participating in PARAKH</h3>
    <div class="container h-100">
        <div class="d-flex justify-content-center h-100 mb-4">
          <div class="searchbar">
            <input matinput (keyup)="applyFilter()" [(ngModel)]="searchText" placeholder="Type keywords to find answers" type="text" id="searchInput" class="search_input" name="search">
            <a class="search_icon"><i class="fa fa-search"></i></a>
          </div>
        </div>
        <form [formGroup]="filterForm" autocomplete="off">
          <!-- <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
              <mat-label>AICTE ID</mat-label>
              <input matInput placeholder="AICTE ID">
          </mat-form-field> -->
     
          <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
              <mat-label>State</mat-label>
              <mat-select formControlName="state" multiple (selectionChange)="getDistrictByMultiStates($event)" >
                  <mat-option *ngFor='let state of states' [value]="state['id']">{{state['state']}}</mat-option>
              </mat-select>
          </mat-form-field>

          <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
            <mat-label>District</mat-label>
            <mat-select formControlName="district" multiple >
                <mat-option *ngFor='let district of districts' [value]="district['name']">{{district['name']}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
            <mat-label>Type of Institute </mat-label>
            <mat-select formControlName="instType" multiple >
                <mat-option *ngFor='let instType of instTypes' [value]="instType['inst_type']">{{instType['inst_type']}}</mat-option>
            </mat-select>
         </mat-form-field>

          <!-- <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
            <mat-label>Women Institute</mat-label>
            <mat-select formControlName="womenInst" >
                <mat-option value="Y">Yes</mat-option>
                <mat-option value="N">No</mat-option>
            </mat-select>
          </mat-form-field>
     
          <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
              <mat-label>NBA Accreditated</mat-label>
              <mat-select formControlName="nba" >
                  <mat-option value="Yes">Yes</mat-option>
                  <mat-option value="No">No</mat-option>
              </mat-select>
          </mat-form-field> -->

          <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
            <mat-label>Institute PID</mat-label>
            <input matInput placeholder="Institute PID" formControlName="pid" maxlength="100">
          </mat-form-field>
     
          <mat-form-field [floatLabel]="'never'" class="col-2" style="margin-left: 30px;">
              <mat-label>Email</mat-label>
              <input matInput placeholder="Email" formControlName="email" maxlength="100">
          </mat-form-field>
     
          <button class="LoginBtn" type="submit" (click)="getAllInstitutes()">Apply Filter</button>
      
      </form>
      </div>
    </div>

  <div class="loading-indicator" *ngIf="showMatSpinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <div class="container nopad mb-5">
    <!-- <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12 nopad">
        <h2 class="SectionHeading">Institute Details</h2>
      </div>
    </div>  -->
    <mat-card class="mat-elevation-z8 mt-4">
      <!-- <div class="row">
        <div class="col-md-12 col-sm-12 col-xs-12 nopad"></div>
      </div>
      <div class="mt-2 mb-3">
        
      </div> -->
      <div class="">
        <table mat-table [dataSource]="dataSource" class="w-100">
      
          <!-- serial Column -->
          <ng-container matColumnDef="serial">
            <th mat-header-cell *matHeaderCellDef> S.No. </th>
            <td mat-cell *matCellDef="let element; let i=index;"> {{paginator.pageIndex == 0 ? i + 1 : 1 + i + paginator.pageIndex * paginator.pageSize}} </td>
          </ng-container>
      
          <!-- instituteName Column -->
          <ng-container matColumnDef="instituteDetails">
            <th mat-header-cell *matHeaderCellDef> Institiute Details </th>
            <td mat-cell *matCellDef="let element">
                <p class="detailInfoText"><span class="infoHeader">Aicte ID: </span> <span>{{element.PERMANENT_ID}}</span></p>
                <p class="detailInfoText"><span class="infoHeader">Name: </span> <span>{{element.CURRENT_INSTITUTE_NAME | titlecase}}</span></p>
                <p class="detailInfoText"><span class="infoHeader">Address: </span> <span>{{element.CURRENT_INSTITUTE_ADDRESS | titlecase}}, {{element.INSTITUTE_DISTRICT | titlecase}}, {{element.INSTI_STATE | titlecase}}</span></p>
                <!-- <p class="detailInfoText"><span class="infoHeader">District: </span> <span>{{element.INSTITUTE_DISTRICT | titlecase}}</span></p>
                <p class="detailInfoText"><span class="infoHeader">State: </span> <span>{{element.INSTI_STATE | titlecase}}</span></p> -->
            </td>
          </ng-container>
      
          <!-- Program Column -->
          <ng-container matColumnDef="program">
            <th mat-header-cell *matHeaderCellDef> Program </th>
            <td mat-cell *matCellDef="let element"> 
              <p class="detailInfoText">
                <span *ngIf="element?.profile == 'Completed' && element?.PROGRAMME != '--' ; else elseProgramme" class="programme">{{element?.PROGRAMME }} </span>
                <ng-template #elseProgramme class="infoStatus pending"> - - </ng-template>
                <!-- <span *ngIf="element?.profile == 'Pending'" class=" infoStatus pending"> - </span> -->
              </p>
            </td>
          </ng-container>
      
          <!-- Activities Column -->
          <ng-container matColumnDef="activities">
            <th mat-header-cell *matHeaderCellDef> Activities </th>
            <td mat-cell *matCellDef="let element">
                <p class="detailInfoText"><span class="infoHeader">Step 1 : </span><span>Registration</span>
                  <span *ngIf="element?.register == 'Completed'" class="infoStatus completed"> {{element.register}} </span>
                  <span *ngIf="element?.register == 'Pending'" class="infoStatus pending"> {{element.register}} </span>
                </p>
                <p class="detailInfoText"><span class="infoHeader">Step 2 : </span><span>Profile Submission</span>
                  <span *ngIf="element?.profile == 'Completed'" class="infoStatus completed"> {{element.profile}} </span>
                  <span *ngIf="element?.profile == 'Pending'" class="infoStatus pending"> {{element.profile}} </span>
                </p>
                <p class="detailInfoText"><span class="infoHeader">Step 3 : </span><span>Students Imported</span>
                  <span *ngIf="element.profile == 'Completed'"> 
                    <span *ngIf="element.regPerc <= 20">
                      <span class="infoStatus pending"> {{element?.students}}</span> 
                      <span class="infoStatus pending"> out of </span>
                      <span class="infoStatus pending" *ngIf="element.TOTAL_ADMISSION">{{element?.TOTAL_ADMISSION}}</span>
                      <span *ngIf="!element.TOTAL_ADMISSION" class="infoStatus pending">0</span>
                    </span>
                    <span *ngIf="element.regPerc > 20 && element.regPerc <=70">
                      <span class="infoStatus inProcess"> {{element?.students}}</span> 
                      <span class="infoStatus inProcess"> out of </span>
                      <span class="infoStatus inProcess" *ngIf="element.TOTAL_ADMISSION">{{element?.TOTAL_ADMISSION}}</span>
                      <span *ngIf="!element.TOTAL_ADMISSION" class="infoStatus inProcess">0</span>
                    </span>
                    <span *ngIf="element.regPerc > 70">
                      <span class="infoStatus completed"> {{element?.students}}</span> 
                      <span class="infoStatus completed"> out of </span>
                      <span class="infoStatus completed" *ngIf="element.TOTAL_ADMISSION">{{element?.TOTAL_ADMISSION}}</span>
                      <span *ngIf="!element.TOTAL_ADMISSION" class="infoStatus completed">0</span>
                    </span>
    
                 </span>
                 <span class="infoStatus" *ngIf="element.profile == 'Pending'">
                  <span class="infoStatus pending"> Pending </span>
                 </span>
                </p>
                <p class="detailInfoText"><span class="infoHeader">Step 4 : </span><span>Assessment Assigned</span>
                  <span class="infoStatus" *ngIf="element.profile == 'Completed'"> 
                    <span *ngIf="element.assessmentPerc <= 20">
                      <span class="infoStatus pending"> {{element?.assessment}} out of {{element?.students}}</span> 
                    </span>
                    <span *ngIf="element.assessmentPerc > 20 && element.assessmentPerc <= 70">
                      <span class="infoStatus inProcess"> {{element?.assessment}} out of {{element?.students}}</span> 
                    </span>
                    <span *ngIf="element.assessmentPerc > 70">
                      <span class="infoStatus completed"> {{element?.assessment}} out of {{element?.students}}</span> 
                    </span>
                  </span>
                  <span class="infoStatus" *ngIf="element.profile == 'Pending'">
                    <span class="infoStatus pending"> Pending </span>
                   </span>
                </p>
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      
        <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                       showFirstLastButtons 
                       aria-label="Select page of periodic elements">
        </mat-paginator>
      </div>
    </mat-card>
  </div>
</section>
